var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStickerGroupSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77 .35v27.3M67.348 4.348l19.304 19.304M67.348 23.652L86.652 4.348M90.65 14h-27.3",
    stroke: "#66D2FF",
    strokeWidth: 2.545
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.764 14A30.243 30.243 0 0014 2.764 30.243 30.243 0 0025.236 14 30.245 30.245 0 0014 25.236 30.245 30.245 0 002.764 14z",
    stroke: "#E58AC5",
    strokeWidth: 2.545,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.842 3.159c4.201-1.45 7.32 1.84 7.658 3.681.338-1.84 3.457-5.13 7.658-3.68 6.208 2.142 6.592 10.255 1.014 15.514-4.253 4.01-8.672 6.876-8.672 6.876s-4.419-2.866-8.672-6.876c-5.577-5.26-5.194-13.372 1.014-15.515z",
    stroke: "#FFAE8A",
    strokeWidth: 2.545,
    strokeLinejoin: "round"
  })));
}
export default SvgStickerGroupSm;